<template>
  <div class="single-press-release-content main-content wide">
    <div class="wrap">
      <sidebar-left />
      <div
        v-if="release"
        class="single-press-release-main-block"
      >
        <share-buttons :preview-text="release.title" />

        <article class="single-press-release">
          <div
            v-if="publishDate"
            class="date"
          >
            {{ publishDate }}
          </div>
          <h1>{{ release.title }}</h1>
          <div
            v-dompurify-html="release.lead"
            class="lead-text"
          />

          <div v-dompurify-html="release.content" />

          <template v-for="(item, index) in release.extraContent">
            <simple-table
              v-if="item.type === 'table' && item.tableData"
              :key="index"
              :table-data="JSON.parse(item.tableData)"
            />

            <div
              v-else-if="item.type === 'wysiwyg'"
              :key="index"
              v-dompurify-html="item.text"
            />
          </template>
        </article>

        <share-buttons :preview-text="release.title" />
        <div class="separator" />
        <single-release-nav :navigation="release.navigation" />
      </div>
    </div>
    <small-loader />
  </div>
</template>

<script>
  import Sidebar from 'components/Sidebar/Sidebar'
  import { mapState } from 'vuex'
  import moment from 'moment'

  export default {
    components: {
      'sidebar-left': Sidebar,
      SingleReleaseNav: () => import(/* webpackChunkName: "single-release-nav" */ 'components/PressReleases/SingleReleaseNav'),
      SimpleTable: () => import(/* webpackChunkName: "simple-table" */ 'components/Tables/SimpleTable'),
      ShareButtons: () => import(/* webpackChunkName: "share-buttons" */ 'components/Buttons/ShareButtons'),
      SmallLoader: () => import(/* webpackChunkName: "small-loader" */ 'components/SmallLoader')
    },

    computed: {
      ...mapState('singleRelease', [
        'release'
      ]),

      publishDate () {
        if (!this.release.date) {
          return ""
        }

        return moment(this.release.date).format('DD.MM.YYYY')
      }
    }
  }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
  @import "~assets/styles/common.scss";

  .single-press-release-content {
    padding: 26px 0 0;

    @include bp-tablet-only {
      padding: 44px 0 82px;
    }

    @include bp-mf-desktop {
      padding: 40px 0 72px;
    }

    .wrap {
      display: flex;
      flex-direction: column;
      @include clearfix();

      @include bp-mf-desktop {
        display: block;
      }

      .separator {
        margin-top: 28px;
        margin-bottom: 28px;
        border-top: 1px solid $grey-border;
      }

      .lead-text {
        margin: 0;
        font-size: em(18);
        font-weight: 300;
        line-height: 26px;

        @include bp-mf-tablet {
          font-size: em(20);
          line-height: 28px;
        }
      }
    }
  }

  .single-press-release-main-block {
    order: 1;
    padding: 0 23px;

    @include bp-tablet-only {
      padding: 0 26px;
    }

    @include bp-mf-desktop {
      float: left;
      vertical-align: top;
      padding: 0;
      width: 66%;
    }

    h1 {
      margin: 0 0 19px;
      font-size: em(32);
      font-weight: 300;
      word-wrap: break-word;

      @include bp-mf-tablet {
        margin: 0 0 26px;
        font-size: em(40);
      }
    }

    .date {
      color: $grey-light;
      margin-bottom: 22px;
    }

    .single-press-release {
      margin-bottom: 30px;

      @include bp-mf-tablet {
        text-align: left;
      }

      h3 {
        margin: 0 0 10px;
        font-size: em(14);
        text-align: left;
      }

      h3,
      /deep/ strong {
        font-weight: 500;
      }

      .content {
        text-align: left;
        font-size: em(13);
        line-height: 18px;
      }

      /deep/ p {
        line-height: 1.5;
        @include bp-mf-tablet {
          margin-bottom: 10px;
        }
      }

      .read-more {
        display: inline-block;
        font-size: em(12);
        line-height: 40px;
        text-decoration: none;
        font-weight: 500;
        color: $blue-medium;

        @include bp-mf-tablet {
          line-height: inherit;
        }

        &:hover {

          @include bp-mf-tablet {
            color: $blue-light;
          }
        }

        &:after {
          content: $icon-arrow-right-thin-medium;
          @include icon-font-thin();
          vertical-align: top;
          margin-left: 3px;
          font-size: 8px;
          font-weight: 700;
          line-height: 40px;

          @include bp-mf-tablet {
            line-height: 14px;
          }
        }
      }
    }
  }

</style>
